<nav class="navbar sticky-top navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid mainContainer">
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo01"
      aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse collapseContainer" id="navbarTogglerDemo01">
      <div class="sideNavContainer">

        <ul class="navbar-nav me-auto mb-2 mb-lg-0 flex-column">
          <li class="nav-item">
            <a class="nav-link" id="profile-tab" data-toggle="tab" routerLink="/home" role="tab" aria-controls="home"
              aria-selected="false" #dashboard="routerLinkActive" [routerLinkActive]="['active']">
              <img src="../../../../../../assets/icons/dashboard.png" class="nav-icon" />
              Dashboard</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="profile-tab" data-toggle="tab" routerLink="/customers" role="tab"
              aria-controls="home" aria-selected="false" #dashboard="routerLinkActive" [routerLinkActive]="['active']">
              <img src="../../../../../../assets/icons/customers.png" class="nav-icon" />
              Customers</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="profile-tab" data-toggle="tab" routerLink="/tenants" role="tab" aria-controls="home"
              aria-selected="false" #dashboard="routerLinkActive" [routerLinkActive]="['active']">
              <img src="../../../../../../assets/icons/star.png" class="nav-icon" />
              Tenants</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="profile-tab" data-toggle="tab" routerLink="/codes" role="tab" aria-controls="home"
              aria-selected="false" #dashboard="routerLinkActive" [routerLinkActive]="['active']">
              <img src="../../../../../../assets/icons/store.png" class="nav-icon" />
              Codes</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="profile-tab" data-toggle="tab" routerLink="/services" role="tab"
              aria-controls="home" aria-selected="false" #dashboard="routerLinkActive" [routerLinkActive]="['active']">
              <img src="../../../../../../assets/icons/services.png" class="nav-icon-services" />
              Services</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="profile-tab" data-toggle="tab" routerLink="/users" role="tab" aria-controls="home"
              aria-selected="false" #dashboard="routerLinkActive" [routerLinkActive]="['active']">
              <img src="../../../../../../assets/icons/users.png" class="nav-icon" />
              Users</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="profile-tab" data-toggle="tab" routerLink="/operations" role="tab"
              aria-controls="home" aria-selected="false" #dashboard="routerLinkActive" [routerLinkActive]="['active']">
              <img src="../../../../../../assets/icons/build.png" class="nav-icon" />
              Operations</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="profile-tab" data-toggle="tab" routerLink="/notifications" role="tab"
              aria-controls="home" aria-selected="false" #dashboard="routerLinkActive" [routerLinkActive]="['active']">
              <img src="../../../../../../assets/icons/notifications.png" class="nav-icon" />
              Notifications</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="profile-tab" data-toggle="tab" routerLink="/sms" role="tab"
              aria-controls="home" aria-selected="false" #dashboard="routerLinkActive" [routerLinkActive]="['active']">
              <img src="../../../../../../assets/icons/sms.png" class="nav-icon" />
              SMS</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" id="profile-tab" data-toggle="tab" routerLink="/promotions" role="tab"
              aria-controls="home" aria-selected="false" #dashboard="routerLinkActive" [routerLinkActive]="['active']">
              <img src="../../../../../../assets/icons/gift.png" class="nav-icon" />
              Promotional Campaigns</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" id="profile-tab" data-toggle="tab" routerLink="/setting" role="tab" aria-controls="home"
              aria-selected="false" #dashboard="routerLinkActive" [routerLinkActive]="['active']">
              <img src="../../../../../../assets/icons/settings.png" class="nav-icon" />
              Settings</a>
          </li>
        </ul>

        <div class="col-md-12 btnCol">
          <div class="btnCol mb-1" (click)="logout()">
            <img src="../../../../../../assets/icons/logout.png" class="btn-icon" />
            Logout
          </div>
          <div class="d-flex justify-content-center mb-1">
            <p class="version">{{appVersion}}</p>
          </div>

        </div>
      </div>
    </div>
  </div>

</nav>